import type { ThemeMode } from "types/app";

export const isDarkTheme = (themeMode: ThemeMode) => themeMode === "dark";
